import { useAccountContext } from "~/v2/providers/AccountProvider";
import { buildAccountHeaderLabel } from "~/v3-poc/features/account-switcher/accountSwitcher.utils";
import { useAtdThemeContext } from "~/v3-poc/features/user-preferences";
import { useAccountCardController } from "./AccountCard.controller";
import { AccountCardPresentation } from "./AccountCard.pres";
import { OverviewAccountChart } from "./OverviewAccountChart.connector";

export const AccountCard = () => {
  const { theme } = useAtdThemeContext();
  const { currentAccount, product } = useAccountContext();
  const accountId = currentAccount?.id;
  const label =
    currentAccount && product
      ? buildAccountHeaderLabel(currentAccount, product)
      : "Account";
  const {
    netLiq,
    change,
    changePercent,
    data,
    baseline,
    lookback,
    onLookbackChange,
    isLoading,
    hasError,
  } = useAccountCardController({ accountId, product });

  return (
    <AccountCardPresentation
      label={label}
      accountId={currentAccount?.account_number ?? accountId ?? "—"}
      netLiq={netLiq}
      change={change}
      changePercent={changePercent}
      lookback={lookback}
      onLookbackChange={onLookbackChange}
      chart={
        <OverviewAccountChart
          data={data}
          baseline={baseline}
          isLoading={isLoading}
          hasError={hasError}
          theme={theme}
        />
      }
    />
  );
};
